import { TextStyle, TextSize, TextFontFamily, TextLineHeight, TextLetterSpacing, TextTransform, TextAlignment, TextColor } from './constants.js';
import { TextDisplayMode, TextWeight, TextDecoration, TextOverflow } from './types.js';
import { getThemeTextStyleValues } from './utils.js';
import React from 'react';
import StyledBaseText from './StyledBaseText.js';
import { TextElement } from './styles.js';
import '../../themes/default/borderRadius/index.js';
import '../../themes/default/borderWidth/index.js';
import '../../themes/default/color/index.js';
import '../../themes/default/shape/index.js';
import '../../themes/default/size/index.js';
import '../../themes/default/spacing/index.js';
import '../../theming/themes/caviar.js';
import '../../theming/themes/merchant.js';
import '../../theming/themes/merchant-next.js';
import '../../theming/themes/internal-tools.js';
import { ThemingContext } from '../../theming/theming.js';
import { TypographyDensities } from '../../theming/typography/constants.js';
import 'lodash.clonedeep';
import 'lodash.merge';
import get from 'lodash.get';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DEFAULT_STYLES = TextStyle.Medium16;

var BaseText = function BaseText(_ref) {
  var _ref$display = _ref.display,
      display = _ref$display === void 0 ? TextDisplayMode.Block : _ref$display,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? DEFAULT_STYLES : _ref$styles,
      mobileStyles = _ref.mobileStyles,
      tabletStyles = _ref.tabletStyles,
      desktopStyles = _ref.desktopStyles,
      wideScreenStyles = _ref.wideScreenStyles,
      tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ["display", "styles", "mobileStyles", "tabletStyles", "desktopStyles", "wideScreenStyles", "tag"]);

  var theme = React.useContext(ThemingContext);

  if (typeof styles === 'string') {
    return /*#__PURE__*/React.createElement(StyledBaseText, _extends({
      mobileStyles: mobileStyles,
      tabletStyles: tabletStyles,
      desktopStyles: desktopStyles,
      wideScreenStyles: wideScreenStyles,
      tag: tag,
      display: display,
      styles: styles
    }, props));
  } // To Do: remove legacy system in v8


  var themeDensityString = "".concat(get(theme, "Typography.Density", TypographyDensities.Regular), "Density");
  var colorProp = props.color || styles && styles.color;
  colorProp = theme.Colors[colorProp] || BaseText.Colors[colorProp];
  var themeDecorationColor = theme.Colors[props.textDecorationColor] || BaseText.Colors[props.textDecorationColor];
  var themeFontFamily = theme.Typography.FontFamily;

  if (typeof mobileStyles === 'string') {
    mobileStyles = getThemeTextStyleValues({
      completeSemanticDefinition: theme.Typography.TextStyles[mobileStyles],
      themeDensityString: themeDensityString,
      defaults: DEFAULT_STYLES
    });
  }

  if (typeof tabletStyles === 'string') {
    tabletStyles = getThemeTextStyleValues({
      completeSemanticDefinition: theme.Typography.TextStyles[tabletStyles],
      themeDensityString: themeDensityString,
      defaults: DEFAULT_STYLES,
      includeDesktopOverrides: true
    });
  }

  if (typeof desktopStyles === 'string') {
    desktopStyles = getThemeTextStyleValues({
      completeSemanticDefinition: theme.Typography.TextStyles[desktopStyles],
      themeDensityString: themeDensityString,
      defaults: DEFAULT_STYLES,
      includeDesktopOverrides: true
    });
  }

  if (typeof wideScreenStyles === 'string') {
    wideScreenStyles = getThemeTextStyleValues({
      completeSemanticDefinition: theme.Typography.TextStyles[wideScreenStyles],
      themeDensityString: themeDensityString,
      defaults: DEFAULT_STYLES,
      includeDesktopOverrides: true
    });
  }

  return /*#__PURE__*/React.createElement(TextElement, _extends({
    as: tag ? tag : undefined,
    themeFontFamily: themeFontFamily,
    textColor: colorProp,
    themeDecorationColor: themeDecorationColor,
    mobileStyles: mobileStyles,
    tabletStyles: tabletStyles,
    desktopStyles: desktopStyles,
    wideScreenStyles: wideScreenStyles,
    display: display,
    styles: styles
  }, props));
};

BaseText.DisplayModes = TextDisplayMode;
BaseText.Sizes = TextSize;
BaseText.Styles = TextStyle;
BaseText.Weights = TextWeight;
BaseText.Families = TextFontFamily;
BaseText.LineHeights = TextLineHeight;
BaseText.LetterSpacings = TextLetterSpacing;
BaseText.TextTransforms = TextTransform;
BaseText.TextAlignments = TextAlignment;
BaseText.TextDecorations = TextDecoration;
BaseText.Overflows = TextOverflow;
BaseText.Colors = TextColor;
var Text = BaseText;
Text.DisplayModes = BaseText.DisplayModes;
Text.Sizes = BaseText.Sizes;
Text.Styles = BaseText.Styles;
Text.Weights = BaseText.Weights;
Text.Families = BaseText.Families;
Text.LineHeights = BaseText.LineHeights;
Text.LetterSpacings = BaseText.LetterSpacings;
Text.TextTransforms = BaseText.TextTransforms;
Text.TextAlignments = BaseText.TextAlignments;
Text.TextDecorations = BaseText.TextDecorations;
Text.Overflows = BaseText.Overflows;
Text.Colors = BaseText.Colors;

export { Text };
